"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var component_1 = __importDefault(require("@loadable/component"));
var react_1 = require("react");
var context_1 = __importDefault(require("../../contexts/lootbox/context"));
var useRequests_1 = __importDefault(require("../../hooks/useRequests"));
var ErrorScreen = (0, component_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require("./components/errorScreen")); }); });
var PlayScreen = (0, component_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require("./components/playScreen")); }); });
var StartScreen = (0, component_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require("./components/startScreen")); }); });
var PendingScreen = (0, component_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require("./components/pendingScreen")); }); });
var FRAMERATE = 1000 / 60;
var LootBoxWidget = function (_a) {
    var gameId = _a.gameId, options = _a.options, playerId = _a.playerId;
    var getMiniGame = (0, useRequests_1.default)().getMiniGame;
    var _b = (0, react_1.useState)(true), showStartScreen = _b[0], setShowScreenStart = _b[1];
    var _c = (0, react_1.useState)(false), showPlayScreen = _c[0], setPlayScreen = _c[1];
    var _d = (0, react_1.useState)(false), showErrorScreen = _d[0], setShowErrorScreen = _d[1];
    var _e = (0, react_1.useState)(false), showPendingScreen = _e[0], setShowPendingScreen = _e[1];
    var _f = (0, react_1.useState)({}), activeMiniGame = _f[0], setActiveMiniGame = _f[1];
    (0, react_1.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = setActiveMiniGame;
                        return [4 /*yield*/, getMiniGame(gameId, options)];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [gameId]);
    var onStart = function () {
        setShowScreenStart(false);
        setPlayScreen(true);
    };
    var hideAllScreens = function () {
        setShowScreenStart(false);
        setPlayScreen(false);
    };
    var onError = function () {
        hideAllScreens();
        setShowErrorScreen(true);
    };
    return ((0, jsx_runtime_1.jsx)(context_1.default, __assign({ customerId: options.customerId, playerId: playerId, campaignId: options.campaignId, miniGame: activeMiniGame }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "lootbox" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "lootbox--wrapper" }, { children: [(0, jsx_runtime_1.jsx)("h1", { children: activeMiniGame.name }), (0, jsx_runtime_1.jsx)(StartScreen, { onStart: onStart, show: showStartScreen, framerate: FRAMERATE }), (0, jsx_runtime_1.jsx)(PlayScreen, { onError: onError, show: showPlayScreen, framerate: FRAMERATE }), (0, jsx_runtime_1.jsx)(ErrorScreen, { show: showErrorScreen }), (0, jsx_runtime_1.jsx)(PendingScreen, { show: showPendingScreen })] })) })) })));
};
exports.default = LootBoxWidget;
